import { getConfig } from '@/js/helpers/config'

export const sendUserData = (): void => {
  const elements = document.querySelectorAll('.form-field-input')
  const formData = {
    customer: {
      email: '',
      first_name: '',
      source_funnel: 'seo_knowledge_base'
    },
    discipline: {
      grade: ''
    }
  }

  elements.forEach((element) => {
    const inputElement = element as HTMLInputElement
    const type = inputElement.getAttribute('type')
    const name = inputElement.getAttribute('name')
    if (type === 'email') {
      formData.customer.email = inputElement.value
    } else if (type === 'text') {
      formData.customer.first_name = inputElement.value
    } else if (name === 'grade') {
      const grade = inputElement.getAttribute('value') || 'K1'
      formData.discipline.grade = grade
    }
  })

  const appUrl = getConfig('BRIGHTERLY_APP_URL')
  const appToken = getConfig('BRIGHTERLY_TOKEN')

  fetch(`${appUrl}/api/customers`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${appToken}`,
      Accept: 'application/json'
    },
    body: JSON.stringify(formData)
  })
    .then((response) => response.json())
    .then((data) => {
      console.log('Success:', data)
    })
    .catch((error) => {
      console.error('Error:', error)
    })
}
